import axiosInstance from './axios';
import { Category } from '../types/product';

export const categoriesAPI = {
  getCategories: async (): Promise<Category[]> => {
    const response = await axiosInstance.get('/categories/');
    return response.data;
  },

  getCategory: async (categoryId: number): Promise<Category> => {
    const response = await axiosInstance.get(`/categories/${categoryId}`);
    return response.data;
  },
};